import { useConversationStore } from "../store/conversationStore";
import { useChannelEvent } from "@/components/realtime";
import { useMemo } from "react";

export const useListenConversation = () => {
  const {
    use: { conversation },
    bind: { loadConversation },
  } = useConversationStore();

  const channelName = useMemo(() => {
    if (!conversation) {
      return "";
    }
    return `conversation._.${conversation.uid}`;
  }, [conversation]);

  useChannelEvent(channelName, "human_agent_hand_off", () => {
    loadConversation().subscribe();
  });
};
